import React, { Component } from 'react';

export class BrandImage extends Component {

    constructor(props) {
        super(props);
        this.state = { };
    }


    render() {
        let imageUrl = `.\\.\\img\\${this.props.quoteData.brandLogoFileName}`;
        return (
            <img className="img-responsive center-block logo-img" src={imageUrl} alt="logo"/>
        );
    }
}